(function() {

	'use strict';

	angular.module('Services').service('CarriersZonesDetailTableService', CarriersZonesDetailTableService);

	CarriersZonesDetailTableService.$inject = ['Carrier', 'TableLiteFactory', 'CommonService'];

	function CarriersZonesDetailTableService(Carrier, TableLiteFactory, CommonService) {

		var tableData = {};

		var activeFilters = {};
		var paginationFilter = {};
		var sortingFilter = {
			page: 0
		};
		var carrierFilters = [];

		var tableStructure = {
            optionAddOns: {
                buttons: [{
                    class: 'btn-primary',
                    label: 'Create New System Zone & Postcode',
                    onClick: function () {
                        $location.path('/carriers/zone-postcodes/new');
                    }
                }]
            },
            headers: [{
                label: 'Carrier',
                viewName: 'carrier',
                filterName: 'carrier',
                filter: {
                    type: 'inputDropdown',
                    placeholder: 'Search',
                    class: 'table-input',
                    items: [{ label: 'pbt', viewName: 'PBT' }, { label: 'simplecarrier', viewName: 'Simple Carrier' }],
                    onSelect: function(){
                        //console.log(this);
                    }
                }
            }, {
                label: 'PROFILE NAME',
                viewName: 'profileName',
                filterName: 'profileName',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                }
            }, {
                label: 'DATE CREATED',
                viewName: 'date_created',
                filterName: 'date_created',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                }
            }, {
                label: 'LAST MODIFIED',
                viewName: 'last_modified',
                filterName: 'last_modified',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                }
            }, {
                label: 'NO SERVICE PROFILES ASSIGNED',
                viewName: 'assigned',
                filterName: 'assigned',
                filter: {
                    type: 'text',
                    placeholder: 'Search'
                }
            }],
			data: [],
			applyFilters: function(item) {
				angular.extend(paginationFilter, {
					size: item,
					page: 0
				});
				sendRequest();
			},
			extractTable: function(form) {

			},
			onPageChanged: function() {
				angular.extend(paginationFilter, {
					page: this.currentPage - 1
				});
				sendRequest();
			},
			rowOnClick: function(item) {},
			resetFilters: resetFilters,
			onInit: function() {
                sendRequest({
                    size: 10,
                    page: 0,
                    sort: 'createdDate,desc'
                });
            },
			totalItems: 2,
			numberOfItems: 10,
			totalPages: 1,
			itemView: 20,
			itemViewRaw: 20,
			currentPage: 1
		};

		function sort(filterName) {
			if (tableData.sort && tableData.sort[0].property !== filterName) {
				sortingFilter.sort = filterName;
			} else if (!tableData.sort || tableData.sort[0].property == filterName &&
				!tableData.sort[0].direction.toLowerCase() == 'desc') {
				sortingFilter.sort = filterName;
			} else if (tableData.sort[0].direction.toLowerCase() == 'asc') {
				sortingFilter.sort = filterName + ',desc';
			} else if (tableData.sort[0].direction.toLowerCase() == 'desc') {
				delete sortingFilter.sort;
				delete paginationFilter.sort;
				delete activeFilters.sort;
			}

			sendRequest(sortingFilter);
		}
        function resetFilters () {
            angular.forEach(tableStructure.headers, function(header){
                if(header.filter.model)
                    header.filter.model = '';
                if(header.filter.toModel)
                    header.filter.toModel = '';
                if(header.filter.fromModel)
                    header.filter.fromModel = '';
                delete activeFilters[header.filterName];
            });
            sendRequest({});
        };
		function evaluateFilter(header) {
			var filter = {};
			if (header.filter.model)
				filter[header.filterName] = header.filter.model;
			else if (activeFilters[header.filterName])
				delete activeFilters[header.filterName];

			return filter;
		}

		function sendRequest(filter) {
			angular.extend(activeFilters, paginationFilter, filter);
			Carrier.getZonePostcodeFileDetail(function(data) {
				tableData = buildTableData(data, activeFilters);
			}, function(err) {
			    tableData = buildTableData(null, activeFilters);
			    console.log(err);
			}, activeFilters);
		};

		function buildTableData(data, pagination, filters, filter) {
			/*** START - Building of Data ***/
			if (pagination)
				paginationFilter = pagination;

			tableData = tableStructure;
			tableData.data = [{
                carrier: {
                    type: 'logotype',
                    imgSrc: '/images/shipping_company_logos/tnt-logo.svg'
                },
                profileName: 'Road Express - Myer',
                date_created: '1 11 2015 14:55',
                last_modified: '9 10 2016 12:35',
                href: '/carriers/system-zones/1'
            }, {
                carrier: {
                    type: 'logotype',
                    imgSrc: '/images/shipping_company_logos/toll.svg'
                },
                profileName: 'Myer Melbourne Store',
                date_created: '7 10 2015 12:35',
                last_modified: '8 10 2016 12:35',
                href: '/carriers/system-zones/2'
            }, {
                carrier: {
                    type: 'logotype',
                    imgSrc: '/images/shipping_company_logos/tnt-logo.svg'
                },
                profileName: 'Myer Melbourne Store',
                date_created: '7 10 2015 12:35',
                last_modified: '8 10 2016 12:35',
                href: '/carriers/system-zones/3'
            }, {
                carrier: {
                    type: 'logotype',
                    imgSrc: '/images/shipping_company_logos/bba_custom.svg'
                },
                profileName: 'Myer Melbourne Store',
                date_created: '7 10 2015 12:35',
                last_modified: '8 10 2016 12:35',
                href: '/carriers/system-zones/4'
            }];
			
			if(filters){
				for (var i = 0; i < tableData.headers.length; i++) {
					if(tableData.headers[i].viewName === 'titleLogo'){
						tableData.headers[i].filter.items = filters;
						tableData.headers[i].filter.model = filter;
					}
				}
			}

			
			/*** END - Building of Data ***/

			return tableData;
		};
		return tableStructure;
	};
})();



// WEBPACK FOOTER //
// ./js/services/tables/CarriersZonesDetailTableService.js